import { useMemo } from 'react';
import { scaleLinear } from 'd3-scale';

function useLinearXScale({
  drawableWidth,
  longestSeriesLength
}) {
  const xScale = useMemo(() => {
    return scaleLinear().range([0, drawableWidth]).domain([0, longestSeriesLength]);
  }, [drawableWidth, longestSeriesLength]);
  return {
    xScale
  };
}

export { useLinearXScale };
